import * as React from "react";
import {Button, Card, Form, Grid, Input} from "semantic-ui-react";
import coreState, {ICoreState} from "../../common/CoreState";
import {UtilityManager} from "../../../core/utility/UtilityManager";
import {StateManager} from "../../../core/utility/StateManager";
import {ICreateOrganizationRequest} from "../../../core/api/organization/request/CreateOrganizationRequest";
import {OrganizationApiService} from "../../../core/api/organization/OrganizationApiService";
import FileBase64 from 'react-file-base64';
import {IFileRequest} from "../../../core/api/common/request/FileRequest";

interface IProps {
    category: string;
    isMultipleLeader: boolean;
    onSuccessRequest(): void;
    onCancelForm(): void;
}

interface IState {
    coreState: ICoreState;
    request: ICreateOrganizationRequest;
    structureFileRequest: IFileRequest | undefined;
    documentationFileRequest: IFileRequest | undefined;
    multipleLeaderRequest: ILeaderData[];
}

interface ILeaderData {
    name: string;
    phoneNumber: string;
    position: string;
}

export class CreateOrganization extends React.Component<IProps, IState> {

    private readonly apiService = new OrganizationApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            coreState,
            request: {
                category: this.props.category,
                description: '',
                documentationImage: '',
                leader: '',
                name: '',
                phoneNumber: '',
                structureImage: '',
                address: '',
                isMultipleLeader: this.props.isMultipleLeader,
                documentationFile: undefined,
                structureFile: undefined
            },
            documentationFileRequest: undefined,
            structureFileRequest: undefined,
            multipleLeaderRequest: [
                {
                    name: '',
                    phoneNumber: '',
                    position: 'DINAS'
                },
                {
                    name: '',
                    phoneNumber: '',
                    position: 'ADAT'
                }
            ]
        }
    }

    public componentDidMount = () => {
        UtilityManager.scrollToEl('organization-create');

    };

    public render() {
        return (
            <Card fluid={true} id='organization-create'>
                <Card.Content>
                    <Card.Header>Tambah Organisasi</Card.Header>
                </Card.Content>
                <Card.Content>

                    <Grid verticalAlign='middle'>
                        <Grid.Row>
                            <Grid.Column width={4} />
                            <Grid.Column width={9}>
                                {this.state.coreState.errorNotification}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                    <Form size='large' onSubmit={this.submitData} loading={this.state.coreState.isLoading}>
                        <Grid verticalAlign='middle'>

                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <label style={{ float: 'right' }}>Nama Organisasi</label>
                                </Grid.Column>
                                <Grid.Column width={9}>
                                    <Input
                                        name="name" id="name"
                                        value={this.state.request.name}
                                        onChange={this.handleChange}
                                        fluid={true} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <label style={{ float: 'right' }}>Alamat</label>
                                </Grid.Column>
                                <Grid.Column width={9}>
                                    <Input
                                        name="address" id="address"
                                        value={this.state.request.address}
                                        onChange={this.handleChange}
                                        fluid={true} />
                                </Grid.Column>
                            </Grid.Row>

                        </Grid>
                            {this.props.isMultipleLeader ? (
                                <Grid verticalAlign='middle'>
                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <label style={{ float: 'right' }}>Nama Kelian Dinas</label>
                                        </Grid.Column>
                                        <Grid.Column width={9}>
                                            <Input
                                                name="name0"
                                                value={this.state.multipleLeaderRequest[0].name}
                                                onChange={(e: any) => this.multipleFormListener(e, 'name',0, 'DINAS')}
                                                fluid={true} />
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <label style={{ float: 'right' }}>No. Telp</label>
                                        </Grid.Column>
                                        <Grid.Column width={9}>
                                            <Input
                                                name="phoneNumber0"
                                                value={this.state.multipleLeaderRequest[0].phoneNumber}
                                                onChange={(e: any) => this.multipleFormListener(e, 'phoneNumber',0, 'DINAS')}
                                                fluid={true} />
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <label style={{ float: 'right' }}>Nama Kelian Adat</label>
                                        </Grid.Column>
                                        <Grid.Column width={9}>
                                            <Input
                                                name="name1"
                                                value={this.state.multipleLeaderRequest[1].name}
                                                onChange={(e: any) => this.multipleFormListener(e, 'name',  1, 'ADAT')}
                                                fluid={true} />
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <label style={{ float: 'right' }}>No. Telp</label>
                                        </Grid.Column>
                                        <Grid.Column width={9}>
                                            <Input
                                                name="phoneNumber1"
                                                value={this.state.multipleLeaderRequest[1].phoneNumber}
                                                onChange={(e: any) => this.multipleFormListener(e, 'phoneNumber', 1, 'ADAT')}
                                                fluid={true} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            ) : (
                                <Grid verticalAlign='middle'>
                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <label style={{ float: 'right' }}>Nama Ketua</label>
                                        </Grid.Column>
                                        <Grid.Column width={9}>
                                            <Input
                                                name="leader" id="leader"
                                                value={this.state.request.leader}
                                                onChange={this.handleChange}
                                                fluid={true} />
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <label style={{ float: 'right' }}>No. Telp</label>
                                        </Grid.Column>
                                        <Grid.Column width={9}>
                                            <Input
                                                name="phoneNumber" id="phoneNumber"
                                                value={this.state.request.phoneNumber}
                                                onChange={this.handleChange}
                                                fluid={true} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            )}
                        <Grid verticalAlign='middle'>
                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <label style={{ float: 'right' }}>Deskripsi</label>
                                </Grid.Column>
                                <Grid.Column width={9}>
                                    <Input
                                        name="description" id="description"
                                        value={this.state.request.description}
                                        onChange={this.handleChange}
                                        fluid={true} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <label style={{ float: 'right' }}>Struktur Organisasi</label>
                                </Grid.Column>
                                <Grid.Column width={9}>
                                    <FileBase64
                                        multiple={false}
                                        onDone={this.structureFormListener} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row>
                                <Grid.Column width={4}>
                                    <label style={{ float: 'right' }}>Dokumentasi Pendukung</label>
                                </Grid.Column>
                                <Grid.Column width={9}>
                                    <FileBase64
                                        multiple={false}
                                        onDone={this.documentationFormListener} />
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Column floated='right' width={12}>
                                <Button type='submit' primary={true}>Simpan</Button>
                                <Button type='button' onClick={this.props.onCancelForm}>Batal</Button>
                            </Grid.Column>
                        </Grid>

                    </Form>
                </Card.Content>
            </Card>
        );
    }

    private submitData = (e: any) => {

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        const request = this.state.request;

        if(this.state.documentationFileRequest !== undefined){
            request.documentationFile = this.state.documentationFileRequest;
        }

        if(this.state.structureFileRequest !== undefined){
            request.structureFile = this.state.structureFileRequest;
        }

        if(this.props.isMultipleLeader){
            request.phoneNumber = '000';
            request.leader = JSON.stringify(this.state.multipleLeaderRequest);
        }

        this.apiService.create(request)
            .then((data: any) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState)
                });

                this.props.onSuccessRequest();

            }).catch((error: any) => {
                this.setState({
                    coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
                });

        });

        e.preventDefault();
    };

    private handleChange = (e: any) => {
        const field = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            request:
                {
                    ...prevState.request,
                    [field]: value
                }
        }));
    };

    private multipleFormListener = (e: any, field:any, index: any, position: string) => {
        const value = e.target.value;

        const data = this.state.multipleLeaderRequest;
        data[index][field] = value;
        data[index].position = position;

        this.setState(prevState => ({
            multipleLeaderRequest: data
        }));
    };

    private structureFormListener = (response: any) => {
        const result: IFileRequest = {
            name: response.name,
            base64: response.base64,
            size: response.file.size,
            type: response.type

        };

        const request = this.state.request;
        request.structureImage = response.name;
        
        this.setState({
            structureFileRequest: result,
            request
        });
    };

    private documentationFormListener = (response: any) => {
        const result: IFileRequest = {
            name: response.name,
            base64: response.base64,
            size: response.file.size,
            type: response.type

        };
        const request = this.state.request;
        request.documentationImage = response.name;

        this.setState({
            documentationFileRequest: result,
            request
        });
    }

}


// WEBPACK FOOTER //
// ./src/component/admin/organization/CreateOrganization.tsx